var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"globalTourism"},[_c('div',{staticClass:"module"},[_c('ul',{staticClass:"ul"},_vm._l((_vm.moduleList),function(item,index){return _c('li',{key:index,staticClass:"li"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.img,"alt":""}})]),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }